<template>
  <el-dropdown @command="handleCommand">
    <div class="avatar-dropdown" style="cursor: pointer;">
      <!-- <el-avatar class="user-avatar"></el-avatar> -->
      <span class="user-avatar-box">
        <img class="user-avatar" src="../../../assets/user_images/defaultAvatar.png" alt="" />
      </span>
      <div class="user-name">
        {{ userInfo.name }}
      </div>
        <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="updatePassword">修改密码</el-dropdown-item>
      <!-- <el-dropdown-item >修改手机号</el-dropdown-item> -->
      <el-dropdown-item command="logout">退出登录</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { recordRoute } from '@/config'
  import { getStorage } from '@/utils/index'
  export default {
    name: 'VabAvatar',
    computed: {
    },
    data () {
      return {
        userInfo: getStorage('USER_INFO')
      }
    },
    methods: {
      handleCommand(command) {
        switch (command) {
          case 'logout':
            this.logout()
            break
          case 'updatePassword':
            this.updatePassword()
            break
        }
      },
      updatePassword() {
        this.$store.dispatch('user/setDialogShow', true)
      },
      logout() {
        this.$baseConfirm(
          '是否确认退出登录？',
          {
            title: '提示',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showClose: false,
            type: 'warning',
          },
          async () => {
            await this.$store.dispatch('user/logout')
            if (recordRoute) {
              const fullPath = this.$route.fullPath
              this.$router.push(`/login?redirect=${fullPath}`)
            } else {
              this.$router.push('/login')
            }
          }
        )
      },
    },
  }
</script>
<style lang="scss" scoped>
  .avatar-dropdown {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
    height: 50px;
    padding: 0;

    .user-avatar-box{
      border: 1px solid #F2F3F5;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      position: relative;
      .user-avatar {
        width: 35px;
        height: 35px;
        // cursor: pointer;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .user-name {
      position: relative;
      margin-left: 10px;
      margin-right: 30px;
      // cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
  }
</style>
